export default class SubnavScroll {
  constructor() {
    // Only initialize if element exists
    const scrollContainer = document.querySelector('.subhead-scroll');
    if (scrollContainer) {
      this.list = scrollContainer.querySelector('ul');
      if (this.list) {
        //this.init();
      }
    }
  }

  init() {
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;

    // Enable horizontal scroll by style
    this.list.style.overflowX = 'auto';
    this.list.style.whiteSpace = 'nowrap';
    this.list.style.webkitOverflowScrolling = 'touch';
    this.list.style.cursor = 'grab';

    // Bind handlers
    this.touchStartHandler = this.touchStartHandler.bind(this);
    this.touchMoveHandler = this.touchMoveHandler.bind(this);
    this.touchEndHandler = this.touchEndHandler.bind(this);

    this.mouseDownHandler = this.mouseDownHandler.bind(this);
    this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    this.mouseUpHandler = this.mouseUpHandler.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);

    // Touch events
    this.list.addEventListener('touchstart', this.touchStartHandler, { passive: false });
    this.list.addEventListener('touchmove', this.touchMoveHandler, { passive: false });
    this.list.addEventListener('touchend', this.touchEndHandler);

    // Mouse events
    this.list.addEventListener('mousedown', this.mouseDownHandler);
    this.list.addEventListener('mousemove', this.mouseMoveHandler);
    this.list.addEventListener('mouseup', this.mouseUpHandler);
    this.list.addEventListener('mouseleave', this.mouseLeaveHandler);
  }

  touchStartHandler(e) {
    this.isDragging = true;
    this.startX = e.touches[0].pageX - this.list.offsetLeft;
    this.scrollLeft = this.list.scrollLeft;
  }

  touchMoveHandler(e) {
    if (!this.isDragging) return;
    const x = e.touches[0].pageX - this.list.offsetLeft;
    const walk = x - this.startX;
    this.list.scrollLeft = this.scrollLeft - walk;
    console.log(this.list.scrollLeft);
    e.preventDefault();
  }

  touchEndHandler() {
    this.isDragging = false;
  }

  mouseDownHandler(e) {
    this.isDragging = true;
    this.startX = e.pageX - this.list.offsetLeft;
    this.scrollLeft = this.list.scrollLeft;
    this.list.style.cursor = 'grabbing';
  }

  mouseMoveHandler(e) {
    if (!this.isDragging) return;
    const x = e.pageX - this.list.offsetLeft;
    const walk = x - this.startX;
    this.list.scrollLeft = this.scrollLeft - walk;
  }

  mouseUpHandler() {
    this.isDragging = false;
    this.list.style.cursor = 'grab';
  }

  mouseLeaveHandler() {
    this.isDragging = false;
    this.list.style.cursor = 'grab';
  }
}
